define('helperContent-getQuizGame',['helperContent-getEntity'], function(getEntity) {
    'use strict';

    var getQuizGame = function f(ID, contentEntities) {
        var i = 0,
            entity = getEntity(ID, contentEntities),
            componentsJSON,
            res = {
                ID: '',
                isQuizGame: false,
                componentContent: null
            };

        if (entity === null) {
            return res;
        }

        componentsJSON = (entity.contentEntity.componentsJson) ? JSON.parse(entity.contentEntity.componentsJson) : [];

        i = componentsJSON.length;

        while(i--) {
            if (componentsJSON[i].hasOwnProperty('kind') && componentsJSON[i].kind && componentsJSON[i].kind.toLowerCase() === 'quizgame' && componentsJSON[i].hasOwnProperty('content')) {

                res = {
                    ID: entity.contentEntityId,
                    isQuizGame: true,
                    componentContent: componentsJSON[i].content
                };

                return res;
            }
        }

        if (entity.contentEntity.parentId) {
            return f(entity.contentEntity.parentId, contentEntities);
        }

        return res;
    };

    return getQuizGame;
});

